<template>
  <div v-if="latestData">
      <div class="metrics-cards full-width">
        <div class="metric-card">
            <div class="metric-label">Total BTC</div>
            <div class="metric-value">{{ latestData.BTCBalance.toFixed(3) }} BTC</div>
            <div class="metric-secondary">MV ≈ ${{ latestData.BTCValue.toFixed(2) }}</div>
        </div>

        <div class="metric-card">
            <div class="metric-label">Capital Alocado USDT</div>
            <div class="metric-value">${{ latestData.totalAllocatedUSD.toFixed(2) }}</div>
            <div class="metric-secondary">Capital disponível: {{ latestData.USDBalance}}</div>
        </div>

        <div class="metric-card">
            <div class="metric-label">Exposição BTC</div>
            <div class="metric-value">{{ latestData.BTCExposure.toFixed(2) }}%</div>
            <div class="metric-secondary">USDT: {{ (100 - latestData.BTCExposure).toFixed(2) }}%</div>
        </div>

        <div class="metric-card">
            <div class="metric-label">PMP vs Mercado</div>
            <div class="metric-value" :class="latestData?.PMPDiffPct >= 0 ? 'profit-positive' : 'profit-negative'">{{ latestData.PMPDiffPct > 0 ? '+' : '' }}{{ latestData.PMPDiffPct.toFixed(2) }}%</div>
            <div class="metric-secondary">PMP: ${{ latestData.PMPGeral.toFixed(2) }} | Mercado: ${{ latestData.latestPrice.toFixed(2) }}</div>
        </div>

        <div class="metric-card">
            <div class="metric-label">Volume Negociado</div>
            <div class="metric-value">{{ periodVolume.totalBtc.toFixed(3) }} BTC</div>
            <div class="metric-secondary">US$ {{ periodVolume.totalUsd.toFixed(2) }}</div>
            <div class="metric-secondary">US$ {{ periodVolume.usdPerCloseDay.toFixed(2) }}/dia ({{ periodVolume.closeDayCount }} dias)</div>
        </div>

        <div class="metric-card">
            <div class="metric-label">Profit Period</div>
            <div class="metric-value" :class="latestData?.pnlOnPeriod >= 0 ? 'profit-positive' : 'profit-negative'">US$ {{ latestData.pnlOnPeriod.toFixed(2) }}</div>
             <div class="metric-secondary">%: {{ latestData.pnlPercentage.toFixed(2) }}%</div>
        </div>

        <div class="metric-card">
            <div class="metric-label">Δ Net PnL</div>
            <div class="metric-value attention">US$ {{ latestData.deltaNetPnl.toFixed(2) }}</div>
            <div class="metric-secondary">
              {{ latestData.startNetPnl.toFixed(0) }} → {{ latestData.endNetPnl.toFixed(0) }}
              | Combinado:
              <span class="attention">US$ {{ latestData.combinedPnl.toFixed(2) }}</span>
            </div>
        </div>
     </div>

    <div class="col-2 left-float">
        <div class="chart-section">
          <EvolStructuralChart :raw-data="rawData" :aggregated-data="aggregatedData" />
        </div>

        <div class="chart-section">
          <EvolPmpChart :time-series="portfolioMetricsTimeSeries" :agg-labels="aggData.aggLabels" />
        </div>

        <div class="chart-section">
          <EvolCostPriceChart :time-series="portfolioMetricsTimeSeries" :agg-labels="aggData.aggLabels" />
        </div>

        <div class="chart-section">
          <EvolNetPnlChart :time-series="portfolioMetricsTimeSeries" :agg-labels="aggData.aggLabels" />
        </div>

        <div class="chart-section">
          <EvolBreakEvenChart :time-series="portfolioMetricsTimeSeries" :agg-labels="aggData.aggLabels" />
          
        </div>
        
        <div class="chart-section">
          <EvolManualsGridChart :time-series="portfolioMetricsTimeSeries" :agg-labels="aggData.aggLabels" :step="2000" />
        </div>

        <div class="chart-section">
          <EvolPnlComparisonChart :time-series="portfolioMetricsTimeSeries" :agg-labels="aggData.aggLabels" />
        </div>
        
    </div>

    <div class="col-2 right-float">

      <!-- <div class="chart-section">
        <h3>Performance Relativa: Variação do Portfólio vs Lucro Realizado</h3>
        <div class="chart-wrapper"> <LineChart :data="relativePerformanceChartData" :options="relativePerformanceChartOptions" />
        </div>
      </div> -->

        <div class="chart-section">
          <EvolManualMovementChart :raw-data="rawData" :aggregated-data="aggregatedData"/>
        </div>

        <div class="chart-section">
          <EvolManualOpenChart :raw-data="rawData" :aggregated-data="aggregatedData"/>
        </div>

        <div class="chart-section">
          <EvolAmmoChart :raw-data="rawData" :aggregated-data="aggregatedData"/>
        </div>

        <div class="chart-section exit-quality-section">
          <EvolExitQualityChart :raw-data="rawData" :aggregated-data="aggregatedData"/>
        </div>

        <div class="chart-section">
        <EvolAllocationChart :agg-metrics="aggData.aggMetrics" :agg-labels="aggData.aggLabels"/>
        </div>
        
    </div>
  </div>
  <div v-else><h3>Nenhum dado recebido. Selecione data</h3></div>
</template>

<script>
import { mapState } from 'vuex';
import { labelFormatted } from '../utils/aggregateLogs.js';
import { CLOSE_PURPOSES, extractLogDay } from '../utils/manualChartDays.js';
import { calcManualsNetPnl } from '../utils/funcs.js';
import EvolAllocationChart from './EvolAllocationChart.vue';
import EvolManualsGridChart from './EvolManualsGridChart.vue';
import EvolManualMovementChart from './EvolManualMovementChart.vue';
import EvolManualOpenChart from './EvolManualOpenChart.vue';
import EvolExitQualityChart from './EvolExitQualityChart.vue';
import EvolAmmoChart from './EvolAmmoChart.vue';
import EvolBreakEvenChart from './EvolBreakEvenChart.vue';
import EvolPnlComparisonChart from './EvolPnlComparisonChart.vue';
import EvolStructuralChart from './EvolStructuralChart.vue';
import EvolPmpChart from './EvolPmpChart.vue';
import EvolCostPriceChart from './EvolCostPriceChart.vue';
import EvolNetPnlChart from './EvolNetPnlChart.vue';

export default {
  name: 'EvolCustomMetrics',
  components: { EvolAllocationChart, EvolManualsGridChart, EvolManualMovementChart, EvolManualOpenChart, EvolExitQualityChart, EvolAmmoChart, EvolBreakEvenChart, EvolPnlComparisonChart, EvolStructuralChart, EvolPmpChart, EvolCostPriceChart, EvolNetPnlChart },
  props: {
    aggregatedData: { type: Array, default: () => [] },
    rawData: { type: Array, default: () => [] },
    aggregationMode: { type: String, default: 'time' },
    aggregationOptions: { type: Object, default: () => ({}) },
    totalCapitalUSD: { type: Number, default: 96000 }
  },
  computed: {
    ...mapState(['marketData']),

    aggData() {
      const aggMetrics = this.aggregatedData?.filter(log => log.metrics);
      const aggLabels = this.aggregatedData?.map(log => labelFormatted(log.processedAt));
      //console.log('aggMetrics:', aggMetrics, 'aggLabels:', aggLabels);
      return { aggMetrics, aggLabels };
    },

    hasData() {
      return this.aggData.aggMetrics.length > 0 && !!this.aggData.aggLabels;
    },

    portfolioMetricsTimeSeries() {
      if (!this.hasData) return [];
      return this.aggData.aggMetrics.map((log, index) => {
        const m = log.metrics;
        const qtyRegular = m.portfolioVolumeRegulars || 0;
        const qtyManual = m.portfolioVolumeManuals || 0;
        const totalQty = qtyRegular + qtyManual;
        const pmpGeral = totalQty === 0 ? 0 : ((qtyRegular * (m.portfolioPMPRegulars || 0)) + (qtyManual * (m.portfolioPMPManuals || 0))) / totalQty;
        return { index, m, totalQty, pmpGeral };
      });
    },

    periodVolume() {
      const tradePurposes = CLOSE_PURPOSES;

      let totalBtc = 0;
      let totalUsd = 0;
      const closeDays = new Set();

      for (const log of this.rawData || []) {
        if (log.processed === false) continue;
        if (!tradePurposes.has(log.purpose)) continue;

        const orderData = log.orderData || {};
        const price = Number(
          orderData.price ??
          orderData.execPrice ??
          orderData.avgPrice ??
          log.price ??
          0
        );
        const qty = Number(
          orderData.qty ??
          orderData.executedQty ??
          orderData.totalFilledQty ??
          log.qty ??
          0
        );

        if (!Number.isFinite(qty) || qty <= 0) continue;

        const day = extractLogDay(log);
        if (day?.dayKey) closeDays.add(day.dayKey);

        totalBtc += qty;
        if (Number.isFinite(price) && price > 0) {
          totalUsd += price * qty;
        }
      }

      const closeDayCount = closeDays.size;
      const usdPerCloseDay = closeDayCount > 0 ? totalUsd / closeDayCount : 0;

      return { totalBtc, totalUsd, closeDayCount, usdPerCloseDay };
    },

    latestData() {
      if (!this.hasData) return null;

      const last = this.portfolioMetricsTimeSeries[this.portfolioMetricsTimeSeries.length - 1];
      const { m, pmpGeral: PMPGeral } = last;

      const regularAllocated = (m.portfolioVolumeRegulars || 0) * (m.portfolioPMPRegulars || 0);
      const manualAllocated = (m.portfolioVolumeManuals || 0) * (m.portfolioPMPManuals || 0);
      const USDBalance = this.totalCapitalUSD
      const BTCBalance = (m.portfolioVolumeRegulars || 0) + (m.portfolioVolumeManuals || 0);
      const BTCValue = BTCBalance * (m.currentPrice || 0);
      const latestPrice = this.marketData.btcUsd || 0;

      const totalAllocatedUSD = regularAllocated + manualAllocated;
      const BTCExposure = (totalAllocatedUSD / USDBalance) * 100;
      const PMPDiffPct = PMPGeral > 0 ? ((latestPrice - PMPGeral) / PMPGeral) * 100 : 0;
      const pnlOnPeriod = Number(m.pnl || 0);
      const pnlPercentage = pnlOnPeriod / USDBalance * 100;

      const first = this.portfolioMetricsTimeSeries[0];
      const startNetPnl = calcManualsNetPnl(first.m);
      const endNetPnl = calcManualsNetPnl(m);
      const deltaNetPnl = endNetPnl - startNetPnl;
      const combinedPnl = pnlOnPeriod + deltaNetPnl;

      return { BTCBalance, USDBalance, BTCValue, BTCExposure, PMPGeral, PMPDiffPct, totalAllocatedUSD, latestPrice, pnlOnPeriod, pnlPercentage, startNetPnl, endNetPnl, deltaNetPnl, combinedPnl };
    },

  },
  methods: {}
}
</script>

<style scoped>
.exposure-container {
  padding: 20px;
}

.chart-section {
  height: 600px !important;
}

.chart-section.exit-quality-section {
  height: auto !important;
  min-height: 980px;
}

.metrics-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.metric-card {
  background-color: var(--table-header-bgcolor);
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.metric-label {
  font-size: 0.9em;
  color: var(--text-color);
  opacity: 0.7;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.metric-value {
  font-size: 1.8em;
  font-weight: 700;
  margin-bottom: 5px;
}

.metric-secondary {
  font-size: 0.95em;
  color: var(--text-color);
  opacity: 0.6;
}

.profit-positive {
  color: #4ade80 !important;
}

.profit-negative {
  color: #f87171 !important;
}

.col-2 {
  width: 50%;
  float: left;
  box-sizing: border-box;
  padding: 0 10px;
}
</style>
